import { i18n } from 'i18n';
import { IBadRequestAdditionalData } from 'shared/typings';

export const ERRORS: { [key: string]: (data?: IBadRequestAdditionalData) => string } = {
	'Must be a valid UUID.': () => i18n.t('Некорректный UUID'),
	'Invalid channels provided.': () => i18n.t('Некорректный канал'),
};
